import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDeps, TIconButton } from './models';
import { IconButton as ComponentIconButton } from './icon-button';
import styles from './styles.css';

export const IconButton = createWidget<IDeps, TIconButton>({
    styles,
})(ComponentIconButton);
